import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import thirtyFourALogo from "../../34a.png";
import gsskLogo from "../../gssk.png";
import aevoLogo from "../../aevo.png";
import akLogo from "../../gg_ak.png";
import bkLogo from "../../gg_bk.png";
import wskbLogo from "../../wskb.png";
import wsksLogo from "../../wsks.png";
import ikLogo from "../../ik.png";
import { Card } from './Card';

export class DefaultPage extends Component {
  static propTypes = {
    products: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="content-animate">
        <h1>Produkte</h1>
        <div className="row">
          <Card logo={thirtyFourALogo} title="34a" url="https://www.appucations.de/34a/" />
          <Card logo={gsskLogo} title="GSSK" url="https://www.appucations.de/gssk/" />
          <Card logo={ikLogo} title="Interventionskraft" url="https://www.appucations.de/interventionskraft/" />
        </div>
        <div className="row">
          <Card logo={aevoLogo} title="AEVO Coach" url="https://www.appucations.de/aevo-coach/" />
          <Card logo={wskbLogo} title="Waffensachkunde Bewachung" url="https://www.appucations.de/waffensachkunde-bewachung/" />
          <Card logo={wsksLogo} title="Waffensachkunde Sportschütze" url="https://www.appucations.de/waffensachkunde-sportschuetze/" />
        </div>
        <div className="row">
          <Card logo={bkLogo} title="Gefahrgutfahrer Basiskurs" url="https://www.appucations.de/gefahrgutfahrer-basiskurs/" />
          <Card logo={akLogo} title="Gefahrgutfahrer Auffrischungskurs" url="https://www.appucations.de/gefahrgutfahrer-auffrischungskurs/" />
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    products: state.products,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/products/DefaultPage.js